module.exports = __webpack_public_path__ + "img/s1.8cca404f.png";